import React from 'react';
import { get, findIndex } from 'lodash';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './AccessAppPermission.css';
import Row from './Row';

class AccessAppPermission extends React.Component {
  render() {
    const { roleDetail, permissions, hideUnassignablePermissions } = this.props;
    return (
      <div className={`row ${styles['access-app-permission-container']}`}>
        <div className="col-lg-1" />
        <div className="col-lg-12">
          <div className="row">
            {permissions
              .filter(
                permission =>
                  !hideUnassignablePermissions ||
                  permission.level >= get(roleDetail, 'level', 3)
              )
              .map(permission => {
                return (
                  <Row
                    key={permission.id}
                    checked={this._isChecked(permission)}
                    onChangeCheckbox={this._onChangeCheckbox}
                    permission={permission}
                    isMokaPayUser={this.props.isMokaPayUser}
                  />
                );
              })}
          </div>
        </div>
      </div>
    );
  }

  _isChecked = permission => {
    const { fields } = this.props;
    const currentValue = fields.getAll();
    return findIndex(currentValue, { id: permission.id }) !== -1;
  };

  _onChangeCheckbox = permission => {
    const { fields } = this.props;
    const currentValue = fields.getAll();
    const index = findIndex(currentValue, { id: permission.id });
    if (index === -1) {
      fields.push(permission);
    } else {
      fields.remove(index);
    }
  };
}

const mapFlagsToProps = flags => ({
  hideUnassignablePermissions: flags.hideUnassignablePermissions,
});

export default withFeatureFlags(mapFlagsToProps)(AccessAppPermission);
